export default {"src":"/_next/static/media/bos.4526d7f6.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};